<template>
  <a class="btn btn-default" :href="editStrategyUrl">
    <i class="fa fa-pencil"/>
    Edit
  </a>
</template>

<script>
import { toolkitUrls } from '@/links'

export default {
  name: 'StrategyEditButton',
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  computed: {
    editStrategyUrl() {
      return toolkitUrls.editorLinks.editStrategy(this.uuid)
    }
  }
}
</script>

<style>
</style>
